import {css} from "lit-element/lit-element.js";
export default css`/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* Z-index mapping for the floating elements */
/* Transitions */
.datepicker {
  width: min-content;
}
.datepicker:not(.active) {
  display: none;
}

.datepicker-dropdown {
  position: absolute;
  z-index: 20;
  padding-top: 4px;
}
.datepicker-dropdown.datepicker-orient-top {
  padding-top: 0;
  padding-bottom: 4px;
}

.datepicker-picker {
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  background-color: hsl(0, 0%, 100%);
}
.datepicker-dropdown .datepicker-picker {
  box-shadow: 0 2px 3px rgba(10.2, 10.2, 10.2, 0.1), 0 0 0 1px rgba(10.2, 10.2, 10.2, 0.1);
}

.datepicker-main {
  flex: auto;
  padding: 2px;
}

.datepicker-footer {
  box-shadow: inset 0 1px 1px rgba(10.2, 10.2, 10.2, 0.1);
  background-color: hsl(0, 0%, 96%);
}

.datepicker-title {
  box-shadow: inset 0 -1px 1px rgba(10.2, 10.2, 10.2, 0.1);
  background-color: hsl(0, 0%, 96%);
  padding: 0.375rem 0.75rem;
  text-align: center;
  font-weight: 700;
}

.datepicker-controls {
  display: flex;
}
.datepicker-header .datepicker-controls {
  padding: 2px 2px 0;
}
.datepicker-controls .button {
  display: inline-flex;
  position: relative;
  align-items: center;
  justify-content: center;
  margin: 0;
  border: 1px solid hsl(0, 0%, 86.4%);
  border-radius: 4px;
  box-shadow: none;
  background-color: hsl(0, 0%, 100%);
  cursor: pointer;
  padding: calc(0.375em - 1px) 0.75em;
  height: 2.25em;
  vertical-align: top;
  text-align: center;
  line-height: 1.5;
  white-space: nowrap;
  color: hsl(0, 0%, 21%);
  font-size: 1rem;
}
.datepicker-controls .button:focus, .datepicker-controls .button:active {
  outline: none;
}
.datepicker-controls .button:hover {
  border-color: hsl(0, 0%, 72%);
  color: hsl(0, 0%, 21%);
}
.datepicker-controls .button:focus {
  border-color: hsl(217, 71%, 53%);
  color: hsl(0, 0%, 21%);
}
.datepicker-controls .button:focus:not(:active) {
  box-shadow: 0 0 0 0.125em rgba(50.0565, 115.29485, 220.2435, 0.25);
}
.datepicker-controls .button:active {
  border-color: hsl(0, 0%, 28%);
  color: hsl(0, 0%, 21%);
}
.datepicker-controls .button[disabled] {
  cursor: not-allowed;
}
.datepicker-header .datepicker-controls .button {
  border-color: transparent;
  font-weight: bold;
}
.datepicker-header .datepicker-controls .button:hover {
  background-color: hsl(0, 0%, 97.5%);
}
.datepicker-header .datepicker-controls .button:active {
  background-color: hsl(0, 0%, 95%);
}
.datepicker-footer .datepicker-controls .button {
  flex: auto;
  margin: calc(0.375rem - 1px) 0.375rem;
  border-radius: 2px;
  font-size: 0.75rem;
}
.datepicker-controls .view-switch {
  flex: auto;
}
.datepicker-controls .prev-button,
.datepicker-controls .next-button {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
  flex: 0 0 14.2857142857%;
}
.datepicker-controls .prev-button.disabled,
.datepicker-controls .next-button.disabled {
  visibility: hidden;
}

.datepicker-view,
.datepicker-grid {
  display: flex;
}

.datepicker-view {
  align-items: stretch;
  width: 15.75rem;
}

.datepicker-grid {
  flex-wrap: wrap;
  flex: auto;
}

.datepicker .days {
  display: flex;
  flex-direction: column;
  flex: auto;
}
.datepicker .days-of-week {
  display: flex;
}
.datepicker .week-numbers {
  display: flex;
  flex-direction: column;
  flex: 0 0 9.6774193548%;
}
.datepicker .weeks {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: auto;
}
.datepicker span {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  cursor: default;
  -webkit-touch-callout: none;
  user-select: none;
}
.datepicker .dow {
  height: 1.5rem;
  font-size: 0.875rem;
  font-weight: 700;
}
.datepicker .week {
  flex: auto;
  color: hsl(0, 0%, 72%);
  font-size: 0.75rem;
}

.datepicker-cell, .datepicker .days .dow {
  flex-basis: 14.2857142857%;
}

.datepicker-cell {
  height: 2.25rem;
}
.datepicker-cell:not(.day) {
  flex-basis: 25%;
  height: 4.5rem;
}
.datepicker-cell:not(.disabled):hover {
  background-color: hsl(0, 0%, 97.5%);
  cursor: pointer;
}
.datepicker-cell.focused:not(.selected) {
  background-color: #ced4da;
}
.datepicker-cell.selected, .datepicker-cell.selected:hover {
  background-color: var(--atlas-primary);
  color: #ffffff;
  font-weight: 600;
}
.datepicker-cell.disabled {
  color: #687078;
}
.datepicker-cell.prev:not(.disabled), .datepicker-cell.next:not(.disabled) {
  color: #687078;
}
.datepicker-cell.prev.selected, .datepicker-cell.next.selected {
  color: rgb(229.5, 229.5, 229.5);
}
.datepicker-cell.highlighted:not(.selected):not(.range):not(.today) {
  border-radius: 0;
  background-color: hsl(0, 0%, 96%);
}
.datepicker-cell.highlighted:not(.selected):not(.range):not(.today):not(.disabled):hover {
  background-color: hsl(0, 0%, 93.6%);
}
.datepicker-cell.highlighted:not(.selected):not(.range):not(.today).focused {
  background-color: #ced4da;
}
.datepicker-cell.today:not(.selected) {
  background-color: hsl(171, 100%, 41%);
}
.datepicker-cell.today:not(.selected):not(.disabled) {
  color: #fff;
}
.datepicker-cell.today.focused:not(.selected) {
  background-color: hsl(171, 100%, 39.975%);
}
.datepicker-cell.range-end:not(.selected), .datepicker-cell.range-start:not(.selected) {
  background-color: hsl(0, 0%, 72%);
  color: #ffffff;
}
.datepicker-cell.range-end.focused:not(.selected), .datepicker-cell.range-start.focused:not(.selected) {
  background-color: hsl(0, 0%, 70.2%);
}
.datepicker-cell.range-start:not(.range-end) {
  border-radius: 4px 0 0 4px;
}
.datepicker-cell.range-end:not(.range-start) {
  border-radius: 0 4px 4px 0;
}
.datepicker-cell.range {
  border-radius: 0;
  background-color: hsl(0, 0%, 86.4%);
}
.datepicker-cell.range:not(.disabled):not(.focused):not(.today):hover {
  background-color: hsl(0, 0%, 84.24%);
}
.datepicker-cell.range.disabled {
  color: hsl(0, 0%, 77.76%);
}
.datepicker-cell.range.focused {
  background-color: hsl(0, 0%, 82.08%);
}

.datepicker-input.in-edit {
  border-color: hsl(217, 71%, 50.35%);
}
.datepicker-input.in-edit:focus, .datepicker-input.in-edit:active {
  box-shadow: 0 0 0.25em 0.25em rgba(38.501175, 107.4178575, 218.283825, 0.2);
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@font-face {
  font-family: "Atlas-Icons";
  src: url("fonts/Atlas-Icons.eot?vw7co0");
  src: url("fonts/Atlas-Icons.eot?vw7co0#iefix") format("embedded-opentype"), url("fonts/Atlas-Icons.ttf?vw7co0") format("truetype"), url("fonts/Atlas-Icons.woff?vw7co0") format("woff"), url("fonts/Atlas-Icons.svg?vw7co0#Atlas-Icons") format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
.atlas-icon {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "Atlas-Icons" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.ati-address-book:before {
  content: "\\e900";
}

.ati-alert:before {
  content: "\\e901";
}

.ati-alert-circle:before {
  content: "\\e902";
}

.ati-alert-triangle:before {
  content: "\\e903";
}

.ati-align-justify:before {
  content: "\\e904";
}

.ati-apps:before {
  content: "\\e905";
}

.ati-arrow-down:before {
  content: "\\e906";
}

.ati-arrow-down-circle:before {
  content: "\\e907";
}

.ati-arrow-left:before {
  content: "\\e908";
}

.ati-arrow-right:before {
  content: "\\e909";
}

.ati-arrow-right-left:before {
  content: "\\e90a";
}

.ati-arrow-up:before {
  content: "\\e90b";
}

.ati-arrow-up-circle:before {
  content: "\\e90c";
}

.ati-arrow-up-right:before {
  content: "\\e90d";
}

.ati-asaas-logo:before {
  content: "\\e90e";
}

.ati-backspace:before {
  content: "\\e90f";
}

.ati-banco-do-brasil:before {
  content: "\\e910";
}

.ati-bank:before {
  content: "\\e911";
}

.ati-bar-chart:before {
  content: "\\e912";
}

.ati-barcode:before {
  content: "\\e913";
}

.ati-bars:before {
  content: "\\e914";
}

.ati-base-logo:before {
  content: "\\e915";
}

.ati-bell:before {
  content: "\\e916";
}

.ati-box:before {
  content: "\\e917";
}

.ati-briefcase:before {
  content: "\\e918";
}

.ati-caixa:before {
  content: "\\e919";
}

.ati-calendar:before {
  content: "\\e91a";
}

.ati-calendar-check:before {
  content: "\\e952";
}

.ati-calendar-clock:before {
  content: "\\e9a9";
}

.ati-calendar-magnifier:before {
  content: "\\e9aa";
}

.ati-calendar-sync:before {
  content: "\\e91b";
}

.ati-camera:before {
  content: "\\e91c";
}

.ati-card:before {
  content: "\\e91d";
}

.ati-card-mastercard:before {
  content: "\\e91e";
}

.ati-celebrate:before {
  content: "\\e91f";
}

.ati-check:before {
  content: "\\e920";
}

.ati-check-circle:before {
  content: "\\e921";
}

.ati-check-filled:before {
  content: "\\e922";
}

.ati-chevron-down:before {
  content: "\\e923";
}

.ati-chevron-left:before {
  content: "\\e924";
}

.ati-chevron-right:before {
  content: "\\e925";
}

.ati-chevron-up:before {
  content: "\\e926";
}

.ati-circle:before {
  content: "\\e927";
}

.ati-clock:before {
  content: "\\e928";
}

.ati-clock-filled:before {
  content: "\\e929";
}

.ati-cog:before {
  content: "\\e92a";
}

.ati-concentric-circles:before {
  content: "\\e92b";
}

.ati-contactless:before {
  content: "\\e92c";
}

.ati-copy:before {
  content: "\\e92d";
}

.ati-corner-up-right:before {
  content: "\\e92e";
}

.ati-credisis:before {
  content: "\\e92f";
}

.ati-dashboard:before {
  content: "\\e930";
}

.ati-dollar-sign:before {
  content: "\\e931";
}

.ati-dollar-zap:before {
  content: "\\e932";
}

.ati-double-check:before {
  content: "\\e933";
}

.ati-download:before {
  content: "\\e934";
}

.ati-envelope:before {
  content: "\\e935";
}

.ati-eye:before {
  content: "\\e936";
}

.ati-eye-filled:before {
  content: "\\e937";
}

.ati-eye-off:before {
  content: "\\e938";
}

.ati-eye-off-filled:before {
  content: "\\e939";
}

.ati-facebook:before {
  content: "\\e93a";
}

.ati-file:before {
  content: "\\e93b";
}

.ati-file-check:before {
  content: "\\e93c";
}

.ati-file-dollar:before {
  content: "\\e93d";
}

.ati-file-invoice:before {
  content: "\\e9ab";
}

.ati-file-text:before {
  content: "\\e93e";
}

.ati-file-users:before {
  content: "\\e93f";
}

.ati-files:before {
  content: "\\e940";
}

.ati-filter:before {
  content: "\\e941";
}

.ati-flapp-store-logo:before {
  content: "\\e942";
}

.ati-flash:before {
  content: "\\e943";
}

.ati-gift:before {
  content: "\\e944";
}

.ati-github:before {
  content: "\\e945";
}

.ati-globe:before {
  content: "\\e946";
}

.ati-hammer:before {
  content: "\\e947";
}

.ati-hand-card:before {
  content: "\\e948";
}

.ati-hand-holding-money:before {
  content: "\\e949";
}

.ati-hand-shake:before {
  content: "\\e94a";
}

.ati-help-circle:before {
  content: "\\e94b";
}

.ati-hierarchy:before {
  content: "\\e94c";
}

.ati-home:before {
  content: "\\e94d";
}

.ati-id-card:before {
  content: "\\e94e";
}

.ati-info:before {
  content: "\\e94f";
}

.ati-instagram:before {
  content: "\\e950";
}

.ati-inter:before {
  content: "\\e951";
}

.ati-invoice:before {
  content: "\\e9ab";
}

.ati-itau:before {
  content: "\\e953";
}

.ati-key:before {
  content: "\\e954";
}

.ati-keyboard:before {
  content: "\\e955";
}

.ati-link:before {
  content: "\\e956";
}

.ati-linkedin:before {
  content: "\\e957";
}

.ati-list:before {
  content: "\\e958";
}

.ati-loader:before {
  content: "\\e959";
}

.ati-lock:before {
  content: "\\e95a";
}

.ati-lock-filled:before {
  content: "\\e95b";
}

.ati-log-in:before {
  content: "\\e95c";
}

.ati-magnifier:before {
  content: "\\e95d";
}

.ati-mail-box:before {
  content: "\\e95e";
}

.ati-map-pin:before {
  content: "\\e95f";
}

.ati-market-pin:before {
  content: "\\e960";
}

.ati-maximize:before {
  content: "\\e961";
}

.ati-megaphone:before {
  content: "\\e962";
}

.ati-message-circle:before {
  content: "\\e963";
}

.ati-mic:before {
  content: "\\e964";
}

.ati-minus:before {
  content: "\\e965";
}

.ati-minus-circle:before {
  content: "\\e966";
}

.ati-money:before {
  content: "\\e967";
}

.ati-money-filled:before {
  content: "\\e968";
}

.ati-money-notes:before {
  content: "\\e969";
}

.ati-monitor:before {
  content: "\\e96a";
}

.ati-monitor-chart-up:before {
  content: "\\e96b";
}

.ati-moon:before {
  content: "\\e96c";
}

.ati-nubank:before {
  content: "\\e96d";
}

.ati-open-finance:before {
  content: "\\e96e";
}

.ati-paperclip:before {
  content: "\\e96f";
}

.ati-pencil:before {
  content: "\\e970";
}

.ati-phone:before {
  content: "\\e971";
}

.ati-pix:before {
  content: "\\e972";
}

.ati-plus:before {
  content: "\\e973";
}

.ati-plus-circle:before {
  content: "\\e974";
}

.ati-power:before {
  content: "\\e975";
}

.ati-printer:before {
  content: "\\e976";
}

.ati-receipt:before {
  content: "\\e977";
}

.ati-refresh:before {
  content: "\\e978";
}

.ati-refresh-dollar:before {
  content: "\\e979";
}

.ati-repeat:before {
  content: "\\e97a";
}

.ati-rotate:before {
  content: "\\e97b";
}

.ati-rotate-dollar:before {
  content: "\\e97c";
}

.ati-santander:before {
  content: "\\e97d";
}

.ati-send:before {
  content: "\\e97e";
}

.ati-serasa:before {
  content: "\\e97f";
}

.ati-share:before {
  content: "\\e980";
}

.ati-shield:before {
  content: "\\e981";
}

.ati-shopping-bag:before {
  content: "\\e982";
}

.ati-shopping-cart-down:before {
  content: "\\e983";
}

.ati-shopping-cart-right:before {
  content: "\\e984";
}

.ati-slash:before {
  content: "\\e985";
}

.ati-sliders:before {
  content: "\\e986";
}

.ati-smartphone:before {
  content: "\\e987";
}

.ati-smartphone-contactless:before {
  content: "\\e988";
}

.ati-sort:before {
  content: "\\e989";
}

.ati-spanner:before {
  content: "\\e98a";
}

.ati-split-arrows:before {
  content: "\\e98b";
}

.ati-square:before {
  content: "\\e98c";
}

.ati-square-signs:before {
  content: "\\e98d";
}

.ati-star:before {
  content: "\\e98e";
}

.ati-star-filled:before {
  content: "\\e98f";
}

.ati-sun:before {
  content: "\\e990";
}

.ati-tag:before {
  content: "\\e991";
}

.ati-three-dots:before {
  content: "\\e992";
}

.ati-three-dots-horinzontal:before {
  content: "\\e993";
}

.ati-thumbs-down:before {
  content: "\\e994";
}

.ati-thumbs-up:before {
  content: "\\e995";
}

.ati-ticket:before {
  content: "\\e996";
}

.ati-trash:before {
  content: "\\e997";
}

.ati-truck:before {
  content: "\\e998";
}

.ati-unlink:before {
  content: "\\e999";
}

.ati-unlock:before {
  content: "\\e99a";
}

.ati-unlock-filled:before {
  content: "\\e99b";
}

.ati-upload:before {
  content: "\\e99c";
}

.ati-user:before {
  content: "\\e99d";
}

.ati-user-filled:before {
  content: "\\e99e";
}

.ati-user-plus:before {
  content: "\\e99f";
}

.ati-users:before {
  content: "\\e9a0";
}

.ati-video:before {
  content: "\\e9a1";
}

.ati-virtual-card:before {
  content: "\\e9a2";
}

.ati-wallet:before {
  content: "\\e9a3";
}

.ati-whatsapp:before {
  content: "\\e9a4";
}

.ati-x:before {
  content: "\\e9a5";
}

.ati-x-circle:before {
  content: "\\e9a8";
}

.ati-x-filled:before {
  content: "\\e9a6";
}

.ati-youtube:before {
  content: "\\e9a7";
}

/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
.color-white {
  color: #ffffff !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.color-primary {
  color: var(--atlas-primary) !important;
}

.bg-primary {
  background-color: var(--atlas-primary) !important;
}

.color-primary-100 {
  color: var(--atlas-primary-100) !important;
}

.bg-primary-100 {
  background-color: var(--atlas-primary-100) !important;
}

.color-primary-200 {
  color: var(--atlas-primary-200) !important;
}

.bg-primary-200 {
  background-color: var(--atlas-primary-200) !important;
}

.color-primary-300 {
  color: var(--atlas-primary-300) !important;
}

.bg-primary-300 {
  background-color: var(--atlas-primary-300) !important;
}

.color-primary-400 {
  color: var(--atlas-primary-400) !important;
}

.bg-primary-400 {
  background-color: var(--atlas-primary-400) !important;
}

.color-primary-500 {
  color: var(--atlas-primary-500) !important;
}

.bg-primary-500 {
  background-color: var(--atlas-primary-500) !important;
}

.color-primary-600 {
  color: var(--atlas-primary-600) !important;
}

.bg-primary-600 {
  background-color: var(--atlas-primary-600) !important;
}

.color-primary-700 {
  color: var(--atlas-primary-700) !important;
}

.bg-primary-700 {
  background-color: var(--atlas-primary-700) !important;
}

.color-primary-800 {
  color: var(--atlas-primary-800) !important;
}

.bg-primary-800 {
  background-color: var(--atlas-primary-800) !important;
}

.color-primary-900 {
  color: var(--atlas-primary-900) !important;
}

.bg-primary-900 {
  background-color: var(--atlas-primary-900) !important;
}

.active-primary[active], .active-primary.active, .active-primary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-secondary {
  color: var(--atlas-secondary) !important;
}

.bg-secondary {
  background-color: var(--atlas-secondary) !important;
}

.color-secondary-100 {
  color: var(--atlas-secondary-100) !important;
}

.bg-secondary-100 {
  background-color: var(--atlas-secondary-100) !important;
}

.color-secondary-200 {
  color: var(--atlas-secondary-200) !important;
}

.bg-secondary-200 {
  background-color: var(--atlas-secondary-200) !important;
}

.color-secondary-300 {
  color: var(--atlas-secondary-300) !important;
}

.bg-secondary-300 {
  background-color: var(--atlas-secondary-300) !important;
}

.color-secondary-400 {
  color: var(--atlas-secondary-400) !important;
}

.bg-secondary-400 {
  background-color: var(--atlas-secondary-400) !important;
}

.color-secondary-500 {
  color: var(--atlas-secondary-500) !important;
}

.bg-secondary-500 {
  background-color: var(--atlas-secondary-500) !important;
}

.color-secondary-600 {
  color: var(--atlas-secondary-600) !important;
}

.bg-secondary-600 {
  background-color: var(--atlas-secondary-600) !important;
}

.color-secondary-700 {
  color: var(--atlas-secondary-700) !important;
}

.bg-secondary-700 {
  background-color: var(--atlas-secondary-700) !important;
}

.color-secondary-800 {
  color: var(--atlas-secondary-800) !important;
}

.bg-secondary-800 {
  background-color: var(--atlas-secondary-800) !important;
}

.color-secondary-900 {
  color: var(--atlas-secondary-900) !important;
}

.bg-secondary-900 {
  background-color: var(--atlas-secondary-900) !important;
}

.active-secondary[active], .active-secondary.active, .active-secondary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-success {
  color: var(--atlas-success) !important;
}

.bg-success {
  background-color: var(--atlas-success) !important;
}

.color-success-100 {
  color: var(--atlas-success-100) !important;
}

.bg-success-100 {
  background-color: var(--atlas-success-100) !important;
}

.color-success-200 {
  color: var(--atlas-success-200) !important;
}

.bg-success-200 {
  background-color: var(--atlas-success-200) !important;
}

.color-success-300 {
  color: var(--atlas-success-300) !important;
}

.bg-success-300 {
  background-color: var(--atlas-success-300) !important;
}

.color-success-400 {
  color: var(--atlas-success-400) !important;
}

.bg-success-400 {
  background-color: var(--atlas-success-400) !important;
}

.color-success-500 {
  color: var(--atlas-success-500) !important;
}

.bg-success-500 {
  background-color: var(--atlas-success-500) !important;
}

.color-success-600 {
  color: var(--atlas-success-600) !important;
}

.bg-success-600 {
  background-color: var(--atlas-success-600) !important;
}

.color-success-700 {
  color: var(--atlas-success-700) !important;
}

.bg-success-700 {
  background-color: var(--atlas-success-700) !important;
}

.color-success-800 {
  color: var(--atlas-success-800) !important;
}

.bg-success-800 {
  background-color: var(--atlas-success-800) !important;
}

.color-success-900 {
  color: var(--atlas-success-900) !important;
}

.bg-success-900 {
  background-color: var(--atlas-success-900) !important;
}

.active-success[active], .active-success.active, .active-success:active {
  background-color: var(--atlas-success) !important;
  color: var(--atlas-contrast-success) !important;
}

.color-warning {
  color: var(--atlas-warning) !important;
}

.bg-warning {
  background-color: var(--atlas-warning) !important;
}

.color-warning-100 {
  color: var(--atlas-warning-100) !important;
}

.bg-warning-100 {
  background-color: var(--atlas-warning-100) !important;
}

.color-warning-200 {
  color: var(--atlas-warning-200) !important;
}

.bg-warning-200 {
  background-color: var(--atlas-warning-200) !important;
}

.color-warning-300 {
  color: var(--atlas-warning-300) !important;
}

.bg-warning-300 {
  background-color: var(--atlas-warning-300) !important;
}

.color-warning-400 {
  color: var(--atlas-warning-400) !important;
}

.bg-warning-400 {
  background-color: var(--atlas-warning-400) !important;
}

.color-warning-500 {
  color: var(--atlas-warning-500) !important;
}

.bg-warning-500 {
  background-color: var(--atlas-warning-500) !important;
}

.color-warning-600 {
  color: var(--atlas-warning-600) !important;
}

.bg-warning-600 {
  background-color: var(--atlas-warning-600) !important;
}

.color-warning-700 {
  color: var(--atlas-warning-700) !important;
}

.bg-warning-700 {
  background-color: var(--atlas-warning-700) !important;
}

.color-warning-800 {
  color: var(--atlas-warning-800) !important;
}

.bg-warning-800 {
  background-color: var(--atlas-warning-800) !important;
}

.color-warning-900 {
  color: var(--atlas-warning-900) !important;
}

.bg-warning-900 {
  background-color: var(--atlas-warning-900) !important;
}

.active-warning[active], .active-warning.active, .active-warning:active {
  background-color: var(--atlas-warning) !important;
  color: var(--atlas-contrast-warning) !important;
}

.color-danger {
  color: var(--atlas-danger) !important;
}

.bg-danger {
  background-color: var(--atlas-danger) !important;
}

.color-danger-100 {
  color: var(--atlas-danger-100) !important;
}

.bg-danger-100 {
  background-color: var(--atlas-danger-100) !important;
}

.color-danger-200 {
  color: var(--atlas-danger-200) !important;
}

.bg-danger-200 {
  background-color: var(--atlas-danger-200) !important;
}

.color-danger-300 {
  color: var(--atlas-danger-300) !important;
}

.bg-danger-300 {
  background-color: var(--atlas-danger-300) !important;
}

.color-danger-400 {
  color: var(--atlas-danger-400) !important;
}

.bg-danger-400 {
  background-color: var(--atlas-danger-400) !important;
}

.color-danger-500 {
  color: var(--atlas-danger-500) !important;
}

.bg-danger-500 {
  background-color: var(--atlas-danger-500) !important;
}

.color-danger-600 {
  color: var(--atlas-danger-600) !important;
}

.bg-danger-600 {
  background-color: var(--atlas-danger-600) !important;
}

.color-danger-700 {
  color: var(--atlas-danger-700) !important;
}

.bg-danger-700 {
  background-color: var(--atlas-danger-700) !important;
}

.color-danger-800 {
  color: var(--atlas-danger-800) !important;
}

.bg-danger-800 {
  background-color: var(--atlas-danger-800) !important;
}

.color-danger-900 {
  color: var(--atlas-danger-900) !important;
}

.bg-danger-900 {
  background-color: var(--atlas-danger-900) !important;
}

.active-danger[active], .active-danger.active, .active-danger:active {
  background-color: var(--atlas-danger) !important;
  color: var(--atlas-contrast-danger) !important;
}

.color-highlight {
  color: var(--atlas-highlight) !important;
}

.bg-highlight {
  background-color: var(--atlas-highlight) !important;
}

.color-highlight-100 {
  color: var(--atlas-highlight-100) !important;
}

.bg-highlight-100 {
  background-color: var(--atlas-highlight-100) !important;
}

.color-highlight-200 {
  color: var(--atlas-highlight-200) !important;
}

.bg-highlight-200 {
  background-color: var(--atlas-highlight-200) !important;
}

.color-highlight-300 {
  color: var(--atlas-highlight-300) !important;
}

.bg-highlight-300 {
  background-color: var(--atlas-highlight-300) !important;
}

.color-highlight-400 {
  color: var(--atlas-highlight-400) !important;
}

.bg-highlight-400 {
  background-color: var(--atlas-highlight-400) !important;
}

.color-highlight-500 {
  color: var(--atlas-highlight-500) !important;
}

.bg-highlight-500 {
  background-color: var(--atlas-highlight-500) !important;
}

.color-highlight-600 {
  color: var(--atlas-highlight-600) !important;
}

.bg-highlight-600 {
  background-color: var(--atlas-highlight-600) !important;
}

.color-highlight-700 {
  color: var(--atlas-highlight-700) !important;
}

.bg-highlight-700 {
  background-color: var(--atlas-highlight-700) !important;
}

.color-highlight-800 {
  color: var(--atlas-highlight-800) !important;
}

.bg-highlight-800 {
  background-color: var(--atlas-highlight-800) !important;
}

.color-highlight-900 {
  color: var(--atlas-highlight-900) !important;
}

.bg-highlight-900 {
  background-color: var(--atlas-highlight-900) !important;
}

.active-highlight[active], .active-highlight.active, .active-highlight:active {
  background-color: var(--atlas-highlight) !important;
  color: var(--atlas-contrast-highlight) !important;
}

.color-info {
  color: var(--atlas-info) !important;
}

.bg-info {
  background-color: var(--atlas-info) !important;
}

.color-info-100 {
  color: var(--atlas-info-100) !important;
}

.bg-info-100 {
  background-color: var(--atlas-info-100) !important;
}

.color-info-200 {
  color: var(--atlas-info-200) !important;
}

.bg-info-200 {
  background-color: var(--atlas-info-200) !important;
}

.color-info-300 {
  color: var(--atlas-info-300) !important;
}

.bg-info-300 {
  background-color: var(--atlas-info-300) !important;
}

.color-info-400 {
  color: var(--atlas-info-400) !important;
}

.bg-info-400 {
  background-color: var(--atlas-info-400) !important;
}

.color-info-500 {
  color: var(--atlas-info-500) !important;
}

.bg-info-500 {
  background-color: var(--atlas-info-500) !important;
}

.color-info-600 {
  color: var(--atlas-info-600) !important;
}

.bg-info-600 {
  background-color: var(--atlas-info-600) !important;
}

.color-info-700 {
  color: var(--atlas-info-700) !important;
}

.bg-info-700 {
  background-color: var(--atlas-info-700) !important;
}

.color-info-800 {
  color: var(--atlas-info-800) !important;
}

.bg-info-800 {
  background-color: var(--atlas-info-800) !important;
}

.color-info-900 {
  color: var(--atlas-info-900) !important;
}

.bg-info-900 {
  background-color: var(--atlas-info-900) !important;
}

.active-info[active], .active-info.active, .active-info:active {
  background-color: var(--atlas-info) !important;
  color: var(--atlas-contrast-info) !important;
}

/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-icon,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  display: inline-flex;
}

:host([data-atlas-popover]) {
  cursor: pointer;
}

.atlas-icon {
  line-height: normal;
  animation: none;
}
.atlas-icon.disabled {
  opacity: 0.35;
}

.ati-loader {
  animation: spin 4s linear infinite;
}

.atlas-icon.ati-1x {
  font-size: 8px;
  width: 8px;
  height: 8px;
}

.atlas-icon.ati-2x {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

.atlas-icon.ati-3x {
  font-size: 24px;
  width: 24px;
  height: 24px;
}

.atlas-icon.ati-4x {
  font-size: 32px;
  width: 32px;
  height: 32px;
}

.atlas-icon.ati-5x {
  font-size: 40px;
  width: 40px;
  height: 40px;
}

.atlas-icon.ati-6x {
  font-size: 48px;
  width: 48px;
  height: 48px;
}

.atlas-icon.ati-xs {
  font-size: 8px;
  width: 8px;
  height: 8px;
}

.atlas-icon.ati-sm {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

.atlas-icon.ati-md {
  font-size: 24px;
  width: 24px;
  height: 24px;
}

.atlas-icon.ati-lg {
  font-size: 32px;
  width: 32px;
  height: 32px;
}

.atlas-icon.ati-xl {
  font-size: 40px;
  width: 40px;
  height: 40px;
}

.atlas-icon.ati-xxl {
  font-size: 48px;
  width: 48px;
  height: 48px;
}

.atlas-icon.ati-auto {
  font-size: auto;
  width: auto;
  height: auto;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
.color-white {
  color: #ffffff !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.color-primary {
  color: var(--atlas-primary) !important;
}

.bg-primary {
  background-color: var(--atlas-primary) !important;
}

.color-primary-100 {
  color: var(--atlas-primary-100) !important;
}

.bg-primary-100 {
  background-color: var(--atlas-primary-100) !important;
}

.color-primary-200 {
  color: var(--atlas-primary-200) !important;
}

.bg-primary-200 {
  background-color: var(--atlas-primary-200) !important;
}

.color-primary-300 {
  color: var(--atlas-primary-300) !important;
}

.bg-primary-300 {
  background-color: var(--atlas-primary-300) !important;
}

.color-primary-400 {
  color: var(--atlas-primary-400) !important;
}

.bg-primary-400 {
  background-color: var(--atlas-primary-400) !important;
}

.color-primary-500 {
  color: var(--atlas-primary-500) !important;
}

.bg-primary-500 {
  background-color: var(--atlas-primary-500) !important;
}

.color-primary-600 {
  color: var(--atlas-primary-600) !important;
}

.bg-primary-600 {
  background-color: var(--atlas-primary-600) !important;
}

.color-primary-700 {
  color: var(--atlas-primary-700) !important;
}

.bg-primary-700 {
  background-color: var(--atlas-primary-700) !important;
}

.color-primary-800 {
  color: var(--atlas-primary-800) !important;
}

.bg-primary-800 {
  background-color: var(--atlas-primary-800) !important;
}

.color-primary-900 {
  color: var(--atlas-primary-900) !important;
}

.bg-primary-900 {
  background-color: var(--atlas-primary-900) !important;
}

.active-primary[active], .active-primary.active, .active-primary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-secondary {
  color: var(--atlas-secondary) !important;
}

.bg-secondary {
  background-color: var(--atlas-secondary) !important;
}

.color-secondary-100 {
  color: var(--atlas-secondary-100) !important;
}

.bg-secondary-100 {
  background-color: var(--atlas-secondary-100) !important;
}

.color-secondary-200 {
  color: var(--atlas-secondary-200) !important;
}

.bg-secondary-200 {
  background-color: var(--atlas-secondary-200) !important;
}

.color-secondary-300 {
  color: var(--atlas-secondary-300) !important;
}

.bg-secondary-300 {
  background-color: var(--atlas-secondary-300) !important;
}

.color-secondary-400 {
  color: var(--atlas-secondary-400) !important;
}

.bg-secondary-400 {
  background-color: var(--atlas-secondary-400) !important;
}

.color-secondary-500 {
  color: var(--atlas-secondary-500) !important;
}

.bg-secondary-500 {
  background-color: var(--atlas-secondary-500) !important;
}

.color-secondary-600 {
  color: var(--atlas-secondary-600) !important;
}

.bg-secondary-600 {
  background-color: var(--atlas-secondary-600) !important;
}

.color-secondary-700 {
  color: var(--atlas-secondary-700) !important;
}

.bg-secondary-700 {
  background-color: var(--atlas-secondary-700) !important;
}

.color-secondary-800 {
  color: var(--atlas-secondary-800) !important;
}

.bg-secondary-800 {
  background-color: var(--atlas-secondary-800) !important;
}

.color-secondary-900 {
  color: var(--atlas-secondary-900) !important;
}

.bg-secondary-900 {
  background-color: var(--atlas-secondary-900) !important;
}

.active-secondary[active], .active-secondary.active, .active-secondary:active {
  background-color: var(--atlas-primary) !important;
  color: var(--atlas-contrast-primary) !important;
}

.color-success {
  color: var(--atlas-success) !important;
}

.bg-success {
  background-color: var(--atlas-success) !important;
}

.color-success-100 {
  color: var(--atlas-success-100) !important;
}

.bg-success-100 {
  background-color: var(--atlas-success-100) !important;
}

.color-success-200 {
  color: var(--atlas-success-200) !important;
}

.bg-success-200 {
  background-color: var(--atlas-success-200) !important;
}

.color-success-300 {
  color: var(--atlas-success-300) !important;
}

.bg-success-300 {
  background-color: var(--atlas-success-300) !important;
}

.color-success-400 {
  color: var(--atlas-success-400) !important;
}

.bg-success-400 {
  background-color: var(--atlas-success-400) !important;
}

.color-success-500 {
  color: var(--atlas-success-500) !important;
}

.bg-success-500 {
  background-color: var(--atlas-success-500) !important;
}

.color-success-600 {
  color: var(--atlas-success-600) !important;
}

.bg-success-600 {
  background-color: var(--atlas-success-600) !important;
}

.color-success-700 {
  color: var(--atlas-success-700) !important;
}

.bg-success-700 {
  background-color: var(--atlas-success-700) !important;
}

.color-success-800 {
  color: var(--atlas-success-800) !important;
}

.bg-success-800 {
  background-color: var(--atlas-success-800) !important;
}

.color-success-900 {
  color: var(--atlas-success-900) !important;
}

.bg-success-900 {
  background-color: var(--atlas-success-900) !important;
}

.active-success[active], .active-success.active, .active-success:active {
  background-color: var(--atlas-success) !important;
  color: var(--atlas-contrast-success) !important;
}

.color-warning {
  color: var(--atlas-warning) !important;
}

.bg-warning {
  background-color: var(--atlas-warning) !important;
}

.color-warning-100 {
  color: var(--atlas-warning-100) !important;
}

.bg-warning-100 {
  background-color: var(--atlas-warning-100) !important;
}

.color-warning-200 {
  color: var(--atlas-warning-200) !important;
}

.bg-warning-200 {
  background-color: var(--atlas-warning-200) !important;
}

.color-warning-300 {
  color: var(--atlas-warning-300) !important;
}

.bg-warning-300 {
  background-color: var(--atlas-warning-300) !important;
}

.color-warning-400 {
  color: var(--atlas-warning-400) !important;
}

.bg-warning-400 {
  background-color: var(--atlas-warning-400) !important;
}

.color-warning-500 {
  color: var(--atlas-warning-500) !important;
}

.bg-warning-500 {
  background-color: var(--atlas-warning-500) !important;
}

.color-warning-600 {
  color: var(--atlas-warning-600) !important;
}

.bg-warning-600 {
  background-color: var(--atlas-warning-600) !important;
}

.color-warning-700 {
  color: var(--atlas-warning-700) !important;
}

.bg-warning-700 {
  background-color: var(--atlas-warning-700) !important;
}

.color-warning-800 {
  color: var(--atlas-warning-800) !important;
}

.bg-warning-800 {
  background-color: var(--atlas-warning-800) !important;
}

.color-warning-900 {
  color: var(--atlas-warning-900) !important;
}

.bg-warning-900 {
  background-color: var(--atlas-warning-900) !important;
}

.active-warning[active], .active-warning.active, .active-warning:active {
  background-color: var(--atlas-warning) !important;
  color: var(--atlas-contrast-warning) !important;
}

.color-danger {
  color: var(--atlas-danger) !important;
}

.bg-danger {
  background-color: var(--atlas-danger) !important;
}

.color-danger-100 {
  color: var(--atlas-danger-100) !important;
}

.bg-danger-100 {
  background-color: var(--atlas-danger-100) !important;
}

.color-danger-200 {
  color: var(--atlas-danger-200) !important;
}

.bg-danger-200 {
  background-color: var(--atlas-danger-200) !important;
}

.color-danger-300 {
  color: var(--atlas-danger-300) !important;
}

.bg-danger-300 {
  background-color: var(--atlas-danger-300) !important;
}

.color-danger-400 {
  color: var(--atlas-danger-400) !important;
}

.bg-danger-400 {
  background-color: var(--atlas-danger-400) !important;
}

.color-danger-500 {
  color: var(--atlas-danger-500) !important;
}

.bg-danger-500 {
  background-color: var(--atlas-danger-500) !important;
}

.color-danger-600 {
  color: var(--atlas-danger-600) !important;
}

.bg-danger-600 {
  background-color: var(--atlas-danger-600) !important;
}

.color-danger-700 {
  color: var(--atlas-danger-700) !important;
}

.bg-danger-700 {
  background-color: var(--atlas-danger-700) !important;
}

.color-danger-800 {
  color: var(--atlas-danger-800) !important;
}

.bg-danger-800 {
  background-color: var(--atlas-danger-800) !important;
}

.color-danger-900 {
  color: var(--atlas-danger-900) !important;
}

.bg-danger-900 {
  background-color: var(--atlas-danger-900) !important;
}

.active-danger[active], .active-danger.active, .active-danger:active {
  background-color: var(--atlas-danger) !important;
  color: var(--atlas-contrast-danger) !important;
}

.color-highlight {
  color: var(--atlas-highlight) !important;
}

.bg-highlight {
  background-color: var(--atlas-highlight) !important;
}

.color-highlight-100 {
  color: var(--atlas-highlight-100) !important;
}

.bg-highlight-100 {
  background-color: var(--atlas-highlight-100) !important;
}

.color-highlight-200 {
  color: var(--atlas-highlight-200) !important;
}

.bg-highlight-200 {
  background-color: var(--atlas-highlight-200) !important;
}

.color-highlight-300 {
  color: var(--atlas-highlight-300) !important;
}

.bg-highlight-300 {
  background-color: var(--atlas-highlight-300) !important;
}

.color-highlight-400 {
  color: var(--atlas-highlight-400) !important;
}

.bg-highlight-400 {
  background-color: var(--atlas-highlight-400) !important;
}

.color-highlight-500 {
  color: var(--atlas-highlight-500) !important;
}

.bg-highlight-500 {
  background-color: var(--atlas-highlight-500) !important;
}

.color-highlight-600 {
  color: var(--atlas-highlight-600) !important;
}

.bg-highlight-600 {
  background-color: var(--atlas-highlight-600) !important;
}

.color-highlight-700 {
  color: var(--atlas-highlight-700) !important;
}

.bg-highlight-700 {
  background-color: var(--atlas-highlight-700) !important;
}

.color-highlight-800 {
  color: var(--atlas-highlight-800) !important;
}

.bg-highlight-800 {
  background-color: var(--atlas-highlight-800) !important;
}

.color-highlight-900 {
  color: var(--atlas-highlight-900) !important;
}

.bg-highlight-900 {
  background-color: var(--atlas-highlight-900) !important;
}

.active-highlight[active], .active-highlight.active, .active-highlight:active {
  background-color: var(--atlas-highlight) !important;
  color: var(--atlas-contrast-highlight) !important;
}

.color-info {
  color: var(--atlas-info) !important;
}

.bg-info {
  background-color: var(--atlas-info) !important;
}

.color-info-100 {
  color: var(--atlas-info-100) !important;
}

.bg-info-100 {
  background-color: var(--atlas-info-100) !important;
}

.color-info-200 {
  color: var(--atlas-info-200) !important;
}

.bg-info-200 {
  background-color: var(--atlas-info-200) !important;
}

.color-info-300 {
  color: var(--atlas-info-300) !important;
}

.bg-info-300 {
  background-color: var(--atlas-info-300) !important;
}

.color-info-400 {
  color: var(--atlas-info-400) !important;
}

.bg-info-400 {
  background-color: var(--atlas-info-400) !important;
}

.color-info-500 {
  color: var(--atlas-info-500) !important;
}

.bg-info-500 {
  background-color: var(--atlas-info-500) !important;
}

.color-info-600 {
  color: var(--atlas-info-600) !important;
}

.bg-info-600 {
  background-color: var(--atlas-info-600) !important;
}

.color-info-700 {
  color: var(--atlas-info-700) !important;
}

.bg-info-700 {
  background-color: var(--atlas-info-700) !important;
}

.color-info-800 {
  color: var(--atlas-info-800) !important;
}

.bg-info-800 {
  background-color: var(--atlas-info-800) !important;
}

.color-info-900 {
  color: var(--atlas-info-900) !important;
}

.bg-info-900 {
  background-color: var(--atlas-info-900) !important;
}

.active-info[active], .active-info.active, .active-info:active {
  background-color: var(--atlas-info) !important;
  color: var(--atlas-contrast-info) !important;
}

/* Font family */
/* Display */
/* Heading */
/* Body */
/* Caption */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
/* Border radius */
/* Base borders */
/* ========== BOOTSTRAP COLORS ========== */
/* Contrast ratio */
/* Base colors */
/* Gray variations */
/* Blues variations */
/* Greens variations */
/* Reds variations */
/* Orange variations */
/* Cyans variations */
/* Royal Blue variations */
/* Theme colors */
/* Light variations */
/* Text colors */
/* Border colors */
/* Disabled colors */
/* ========== ATLAS COLORS ========== */
/* Atlas theme colors */
/* Atlas theme contrasts */
/* Atlas theme rgb */
/* Atlas variant primary colors */
/* Atlas variant secondary colors */
/* Atlas variant success colors */
/* Atlas variant warning colors */
/* Atlas variant danger colors */
/* Atlas variant highlight colors */
/* Atlas variant info colors */
/* ========== EXPORTED COLORS ========== */
@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
:host(:not(:defined)) {
  visibility: hidden;
}

:host(:not(atlas-text,
atlas-icon,
atlas-heading,
atlas-caption,
atlas-display,
atlas-page,
atlas-page-content,
atlas-page-tabs-wrapper,
atlas-page-tab,
atlas-layout)) {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

:host([skeleton-loading]) {
  display: contents;
  pointer-events: none;
  user-select: none;
}

@media screen and (min-width: 992px) {
  :host([hide-on-desktop]) {
    display: none !important;
  }
}

@media screen and (max-width: 992px) {
  :host([hide-on-mobile]) {
    display: none !important;
  }
}

.skeleton {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
}
.skeleton::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-circle {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.skeleton-circle::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

.skeleton-pill {
  position: relative;
  background: var(--atlas-secondary-100);
  color: transparent;
  border-radius: 8px !important;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  width: 100%;
  height: auto;
  border-radius: 9999px !important;
}
.skeleton-pill::after {
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
  animation: shimmer 1.5s infinite;
  content: "";
}

:host {
  box-sizing: border-box;
  position: relative;
  width: 100%;
}

.calendar-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.calendar-flags {
  display: flex;
  gap: 2rem;
}
.calendar-flags .flag-item {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1;
}
.calendar-flags .flag-item .flag-badge {
  width: 8px;
  height: 8px;
  border-radius: 1px;
}
.calendar-flags .flag-item .flag-badge.circle {
  border-radius: 50%;
}
.calendar-flags .flag-item atlas-icon-button {
  margin-left: 0.25rem;
}

.atlas-calendar {
  width: 100%;
}
.atlas-calendar .skeleton {
  display: none;
}
.atlas-calendar[skeleton-loading] .skeleton {
  display: block;
}
.atlas-calendar[skeleton-loading] .skeleton ~ * {
  display: none;
}

.datepicker {
  width: 100%;
}
.datepicker .datepicker-picker {
  border: 1px solid #ced4da;
}

.datepicker-header .datepicker-controls {
  padding: 1rem 0;
  width: 84%;
  margin: 0 auto;
  align-items: center;
}
.datepicker-header .datepicker-controls .atlas-datepicker-button {
  display: inline-flex;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  justify-content: center;
}
.datepicker-header .datepicker-controls .atlas-datepicker-button span {
  cursor: pointer;
}
.datepicker-header .datepicker-controls .view-switch {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 1rem;
  line-height: 1;
  color: #212529;
}

.datepicker-main {
  padding: 0 1.5rem 1rem;
  box-sizing: border-box;
  width: 100%;
}
.datepicker-main .datepicker-view {
  width: 100%;
}
.datepicker-main .datepicker-view .days-of-week {
  margin-bottom: 1rem;
}
.datepicker-main .datepicker-view .days-of-week span {
  text-align: center;
  color: var(--atlas-primary);
  font-weight: 400;
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}
.datepicker-main .datepicker-grid {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  row-gap: 0.5rem;
}
.datepicker-main .datepicker-grid.months, .datepicker-main .datepicker-grid.years {
  grid-template-columns: repeat(4, 1fr);
  row-gap: 1.5rem;
}

.datepicker-cell {
  font-family: "Open Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  position: relative;
  height: auto;
  pointer-events: none;
}
.datepicker-cell .badge-container {
  display: flex;
  gap: 0.06rem;
  position: absolute;
  bottom: 1px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  pointer-events: all;
}
.datepicker-cell .badge-container .badge {
  width: 8px;
  height: 8px;
  border-radius: 1px;
}
.datepicker-cell .badge-container .badge.circle {
  border-radius: 50%;
}
.datepicker-cell .cell-content {
  width: 2rem;
  height: 2rem;
  border-radius: 0.25rem;
  box-sizing: border-box;
  pointer-events: all;
  cursor: pointer;
  z-index: 1;
  outline: 1px solid transparent;
  transition: all 0.25s ease;
}
.datepicker-cell .cell-content.skeleton {
  pointer-events: none;
}
.datepicker-cell.month .cell-content, .datepicker-cell.year .cell-content {
  width: 3.75rem;
  height: 3.75rem;
}
.datepicker-cell.in-range {
  background: transparent;
}
.datepicker-cell.in-range .cell-content {
  background: var(--atlas-primary-200);
  color: #ffffff;
  font-weight: 700;
}
.datepicker-cell.in-range .badge {
  background: #ffffff !important;
}
.datepicker-cell.in-range.in-range-no-after .cell-content, .datepicker-cell.in-range.in-range-no-before .cell-content {
  transition: none;
}
.datepicker-cell::after, .datepicker-cell::before {
  content: "";
  top: 0;
  width: 0%;
  height: 100%;
  position: absolute;
  background-color: white;
  transition: width 0.25s linear;
  z-index: 0;
}
.datepicker-cell::before {
  left: 0;
}
.datepicker-cell::after {
  left: 50%;
}
.datepicker-cell.range-start::after, .datepicker-cell.in-range:not(.in-range-no-after)::after {
  background: var(--atlas-primary-200);
  width: 50%;
}
.datepicker-cell.range-end::before, .datepicker-cell.in-range:not(.in-range-no-before)::before {
  background: var(--atlas-primary-200);
  width: 50%;
}
.datepicker-cell.range-end:not(.selected), .datepicker-cell.range-start:not(.selected) {
  background-color: transparent;
}
.datepicker-cell.range-end:not(.selected) .cell-content, .datepicker-cell.range-start:not(.selected) .cell-content {
  background-color: var(--atlas-primary-200);
}
.datepicker-cell:nth-child(1).range-start::before, .datepicker-cell:nth-child(1).in-range::before, .datepicker-cell:nth-child(1).range-end:not(.in-range-no-after)::before, .datepicker-cell:nth-child(7n+8).range-start::before, .datepicker-cell:nth-child(7n+8).in-range::before, .datepicker-cell:nth-child(7n+8).range-end:not(.in-range-no-after)::before {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.datepicker-cell:nth-child(7n).range-start::after, .datepicker-cell:nth-child(7n).in-range:not(.in-range-no-after)::after {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.datepicker-cell.selected, .datepicker-cell.selected:hover {
  background: transparent;
  /* stylelint-disable-next-line no-descending-specificity */
  /* stylelint-enable-next-line no-descending-specificity */
}
.datepicker-cell.selected .cell-content, .datepicker-cell.selected:hover .cell-content {
  background: var(--atlas-primary);
  color: #ffffff;
  font-weight: 700;
}
.datepicker-cell.selected .badge, .datepicker-cell.selected:hover .badge {
  background: #ffffff !important;
}
.datepicker-cell:not(.disabled):hover {
  background: transparent;
}
.datepicker-cell:not(.disabled):hover .cell-content {
  outline: 1px solid var(--atlas-primary);
}
.datepicker-cell.focused:not(.selected) {
  background: transparent;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
